import React from 'react';
import cx from 'classnames';
import styles from './outreachConfigurationView.module.scss';
import { toast } from 'react-toastify';
import LoadingMessage from 'src/legacy/components/LoadingMessage';
import { 
  Row, Col, FormGroup, InputGroup, FormControl, Form
} from 'react-bootstrap';
import SwitchButton from "src/components/switchButton";
import SendButton from 'src/legacy/components/SendButton';
import PlaceholderEmptyMessage from 'src/legacy/components/PlaceholderEmptyMessage';
import AccessDeniedIcon from 'src/legacy/images/access_denied.svg';
import { localizedStrings } from 'src/localization/index.jsx';
import _ from 'lodash';
import Toast from 'src/components/toast';

class OutreachConfigurationView extends React.Component {
  constructor(props){
    super(props);
    const integration = this.props.integration;

    this.state = {
      email: integration && integration.configuration.email || '',
      syncReadAssetEvent: integration && integration.configuration.syncReadAssetEvent || false,
      syncReadConversationEvent: integration && integration.configuration.syncReadConversationEvent || false,
      syncReshareConversationEvent: integration && integration.configuration.syncReshareConversationEvent || false,
      errors: {}
    }

    this._toggleSwitchChange = this._toggleSwitchChange.bind(this);
    this._handleSaveChangesClicked = this._handleSaveChangesClicked.bind(this);
    this._handleResetClicked = this._handleResetClicked.bind(this);

    this.localizedIntegrations = localizedStrings.components.integrations;
    this.localizedCommons = localizedStrings.commons;
    this.localizedOutreach = localizedStrings.components.integrations.outreach;
  }

  componentDidMount() {   
  }

  _toggleSwitchChange(field){

    this.setState({
      [field]: !this.state[field]
    });
  }

  _handleSaveChangesClicked(){
  
    let request = {
      syncReadAssetEvent: this.state.syncReadAssetEvent,
      syncReadConversationEvent: this.state.syncReadConversationEvent,
      syncReshareConversationEvent: this.state.syncReshareConversationEvent
    }

    this.props.updateConfiguration(request).then(() => {
        toast(
          <Toast.Sucess
            message = {this.localizedIntegrations.toast.outreach}            
          /> , {
            autoClose: 3000,
        })
    });
  }

  _handleResetClicked(){
    this.setState({
      syncReadAssetEvent: this.props.integration.configuration.syncReadAssetEvent,
      syncReadConversationEvent: this.props.integration.configuration.syncReadConversationEvent,
      syncReshareConversationEvent: this.props.integration.configuration.syncReshareConversationEvent
    });
  }

  render(){
    return (
      <div className={styles.content}>
        {this.props.integration && this.props.integration.state.code === "auth_error" &&
          <span className={styles.authMessage}>
            {`${this.localizedIntegrations.integration_expired} ${this.props.integration.type}.`}
          </span>
        }

        {this.props.loading && this._renderLoading()}

        {!this.props.loading && this._renderAdminConfiguration()}

      </div>
    )
  }

  _renderAdminConfiguration() {
    return (
        <Row className={styles.row}>
          <Col md={8} mdOffset={1}>
            <div className={styles.form}>
              <p className={styles.errorMessage}>{this.state.errors && this.state.errors.apikey}</p>
              {this.state.email &&
              <FormGroup className={cx(styles.formGroup)}>
              <InputGroup className = {styles.disableEmail}>
                <InputGroup.Text className={styles.start}>
                  <span>{this.localizedCommons.email}</span>
                </InputGroup.Text>
                <FormControl
                  type='text'
                  placeholder=""
                  value={this.state.email}
                  disabled
                  
                   />
              </InputGroup>
              </FormGroup>}
              {this.state.email &&
              <Form.Text>{ this.localizedOutreach.configuration.active }</Form.Text>}

              <FormGroup className={cx(styles.formGroup)}>
                <InputGroup>
                  <h5>{ this.localizedIntegrations.sync_events }</h5>
                </InputGroup>
              </FormGroup>
              <Form.Text>{ this.localizedOutreach.configuration.sync_events.sub_text }</Form.Text>

              <FormGroup className={cx(styles.formGroup, styles.events)}>
                <div className={styles.event}>
                  <label>{ this.localizedIntegrations.configs.view_asset }</label>
                  <SwitchButton 
                    id="syncReadAssetEvent"
                    checked={this.state.syncReadAssetEvent}
                    className={styles.switch}
                    handleCheck={()=>this._toggleSwitchChange("syncReadAssetEvent")} />
                </div>
                <div className={styles.event}>
                  <label>{ this.localizedIntegrations.configs.view_collection }</label>
                  <SwitchButton 
                    className={styles.switch}
                    id="syncReadConversationEvent"
                    checked={this.state.syncReadConversationEvent}
                    handleCheck={()=>this._toggleSwitchChange("syncReadConversationEvent")} />
                </div>
                <div className={styles.event}>
                  <label>{ this.localizedIntegrations.configs.reshare_collection }</label>
                  <SwitchButton 
                    className={styles.switch}
                    id="syncReshareConversationEvent"
                    checked={this.state.syncReshareConversationEvent}
                    handleCheck={()=>this._toggleSwitchChange("syncReshareConversationEvent")} />
                </div>
              </FormGroup>


              <div className={styles.buttonTray}>
                <SendButton
                  className={cx(styles.save)}
                  icon="fa-chevron-right"
                  title={this.props.updating ? `${this.localizedCommons.actions.saving_changes}...` : this.localizedCommons.actions.save }
                  primary
                  disabled={this.props.updating}
                  onClick={this._handleSaveChangesClicked}
                >
                </SendButton>
                <SendButton
                  title={this.localizedCommons.actions.reset}
                  disabled={this.props.updating}
                  className={cx(styles.cancel)}
                  onClick={this._handleResetClicked}
                >
                </SendButton>
              </div>
            </div>
          </Col>
        </Row>
    );
  }

  _renderEmptyMessage() {
    return (
      <PlaceholderEmptyMessage
        title={this.localizedPipedrive.configuration.deactivate_slider.title}
        message={this.localizedPipedrive.configuration.deactivate_slider.sub_text}
        image={AccessDeniedIcon}
        className={styles.emptyMessage}
        visible={true}
      />
    );
  }

  _renderLoading() {
    return (
      <LoadingMessage 
        className={styles.loadingMessage}
        message={`${this.localizedOutreach.loading}...`}
        visible={true} />
    )
  }
}

export default OutreachConfigurationView;